import '@rainbow-me/rainbowkit/styles.css'
import React from 'react'
import {WagmiProvider} from 'wagmi'

import {config} from '@util/wallet'

import {DarkModeStore} from '@store/DarkmodeStore'

const EthereumWalletContextProvider = ({children}: React.PropsWithChildren) => {
    return <WagmiProvider config={config}>{children}</WagmiProvider>
}
export default EthereumWalletContextProvider
